import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 51653,
  clicks: 1167,
  adsSpendDollars: 5401,
  budgetDollars: 5500,
  salesDollars: 9194,
  bestEstimateRoas: 1.7,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 19,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
